import { DeleteOutlined, EditOutlined, MoreOutlined, RedoOutlined, SettingOutlined } from "@ant-design/icons";
import { log } from "@antv/g2plot/lib/utils";
import { render } from "@testing-library/react";
import { Dropdown, Space, Switch, Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const EmployeeWorkInLeaveBenefitTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onDelete = () => { },
  onChange = () => { },
  setIsModalOpen = () => { },
  onToggleChange = () => { }
}) => {

  const { t, i18n } = useTranslation();

  function formatDate(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    return date.format(i18n.language === "en" ? "DD/MM/YYYY" : `DD/MM/${date.year() + 543}`);
  }

  const columns = [
    {
      title: <div className="text-table">{t('workin.no')}</div>,
      key: "no",
      align: "center",
      render: (_, record, idx) => {
        return <span
          style={{
            color: "#313131",
            backgroundColor: "#F5F6F7",
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
          }}
        >
          {(pagination.page - 1) * pagination.size + idx + 1}
        </span>
      },
    },
    {
      title: <div className="text-table">{t('workin.leave-type')}</div>,
      dataIndex: i18n.language === "en" ? "leaveTypeNameEn" : "leaveTypeName",
      key: "leaveType",

    },
    {
      title: <div className="text-table">{t('workin.entitled-leave')} </div>,
      dataIndex: "entitledLeave",
      key: "entitledLeave",
      render: (_, record) => {
        if (record?.unlimited === "Y") {
          return i18n.language === "en" ? "unlimited" : "ไม่จำกัด"

        } else {

          if (i18n.language === "en") {
            if (record?.modifiedStatus === 'Y') {

              return <><SettingOutlined /> <span> {record?.entitledLeave} Days {record?.entitledLeaveHour} Hours</span></>

            } else {
              return record?.entitledLeave + " Days " + record?.entitledLeaveHour + " Hours"
            }
          } else {
            if (record?.modifiedStatus === 'Y') {

              return <><SettingOutlined /> <span> {record?.entitledLeave} วัน {record?.entitledLeaveHour} ชม.</span></>
            } else {
              return record?.entitledLeave + " วัน " + record?.entitledLeaveHour + " ชม."
            }
          }



        }
      },
    },
    {
      title: <div className="text-table">{t('workin.accumulated')}</div>,
      dataIndex: "accumulated",
      key: "accumulated",
      render: (_, record) => {
        if (record?.accumulated == null) {
          return "-"
        } else {
          return i18n.language === 'en' ? record?.accumulated + " Day" : record?.accumulated + " วัน"
        }
      }
    },
    {
      title: <div className="text-table">{t('workin.remaining_leave')}</div>,
      dataIndex: "remaining",
      key: "remaining",
      render: (_, record) => {
        console.log("record.unlimited", record.unlimited);
        const convertLeaveHour = (remainingLeaveHour) => {
          const leaveHour = parseFloat(remainingLeaveHour);

          if (leaveHour !== 0) {
            const decimalPart = leaveHour % 1;
            const convertedMinutes = (decimalPart * 60) / 100;
            return `${(Math.floor(leaveHour) + convertedMinutes).toFixed(2)} ${t("unit.hours")}`;
          }

          return `0.00 ${t("unit.hours")}`;
        };

        const remainingDay = record?.remainingDay !== 0 ? `${record?.remainingDay} ${t("unit.day")}` : ""
        const remainingHour = record?.remainingHour !== 0 ? convertLeaveHour(record?.remainingHour) : ""

        if (record.unlimited === "Y") {
          return <span>{t("unlimited")}</span>
        } else {
          return `${remainingDay} ${remainingHour}`
        }
      },
    },
    {
      title: <div className="text-table">{t('workin.emergency-leave')}</div>,
      dataIndex: "emergencyLeave",
      key: "emergencyLeave",
      width: 180,
      render: (_, record) => {
        return record?.emergencyUsed ? record?.emergencyUsed : "-"
      }
    },
    {
      title: <div className="text-table">{t('workin.expire-in')}</div>,
      dataIndex: "expire",
      key: "expireIn",
      render: (_, record) => {
        return record?.expire ? formatDate(record?.expire) : "-"
      }
    },
    {
      title: <div className="text-table">{t('status.entity')}</div>,
      key: "statusFlag",
      align: "center",
      render: (text, record) => (
        <Space size="middle">
          <Switch
            checked={record?.statusFlag === "ACTIVE"}
            onChange={(checked) => {
              onToggleChange(checked, record)
            }} />
        </Space>
      ),
    },
    {
      title: "",
      key: "action",
      align: "center",
      render: (_, record) => {
        const menuItems = [
          {
            key: "1",
            onClick: () => {
              onEdit(record);
              setIsModalOpen(true);
            },
            label: `${t("action.edit")}`,
            icon: (
              <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
            ),
          },
        ];

        if (record?.modifiedStatus === 'Y') {
          menuItems.push({
            key: "2",
            onClick: () => onDelete(record),
            label: `${t("common.label.reset")}`,
            icon: (
              <RedoOutlined style={{ fontSize: "18px", color: "gray" }} />
            ),
          });
        }

        return (
          <Space size="middle">
            <Dropdown menu={{ items: menuItems }}>
              <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
            </Dropdown>
          </Space>
        )
      },
    },
  ];

  return (
    <>
      <TableAntd
        loading={isLoading}
        pagination={{
          ...pagination,
          showTotal: (total, range) =>
            t("paginate.description")
              .replace("{min}", range[0])
              .replace("{max}", range[1])
              .replace("{total}", total),
        }}
        dataSource={dataSource}
        rowKey={(record) => record.id}
        columns={columns}
        onChange={onChange}
        className="custom-table"
      />
    </>
  );
};

export default EmployeeWorkInLeaveBenefitTable;
